import React from 'react';
import PropTypes from 'prop-types';

const DropDownItem = props => (
    <li
        className={props.liTagClassName}
        // -1 is used to avoid default navigation by each item in the list
        tabIndex={-1}
        onClick={() => props.onDropDownItemClick(props.id)}
    >
        {props.name}
    </li>
);

DropDownItem.propTypes = {
    id: PropTypes.string.isRequired,
    liTagClassName: PropTypes.string.isRequired,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onDropDownItemClick: PropTypes.func.isRequired,
};

export default DropDownItem;
